// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0465a42a","581":"b7470093","667":"54e4089c","977":"50e8f915"}[chunkId] + ".chunk.js";
};